import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPublicOpp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "512pt",
	height: "512pt",
	viewBox: "0 0 512 512",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m399.57 216.75h-29.953v-64.512c0-4.5234-0.25781-8.875-0.68359-13.227-6.7383-57.344-55.293-100.61-112.98-100.61-57.684 0-106.24 43.266-112.89 100.7-0.51172 4.1797-0.76953 8.6172-0.76953 13.141v64.512h-29.867c-11.691 0-21.164 9.5586-21.164 21.246v214.44c0 11.691 9.4727 21.164 21.164 21.164h287.15c11.691 0 21.164-9.4727 21.164-21.164l-0.003906-214.44c0-11.691-9.4688-21.25-21.16-21.25zm-130.82 147.46v29.355c0 7.082-5.7188 12.801-12.801 12.801s-12.801-5.7188-12.801-12.801v-29.355c-14.25-5.207-24.406-18.859-24.406-34.902 0-20.48 16.727-37.121 37.207-37.121s37.207 16.641 37.207 37.121c0 16.043-10.156 29.695-24.406 34.902zm66.73-147.46h-159.06v-64.512c0-3.2422 0.17188-6.3984 0.51172-9.3008 4.6914-40.105 38.656-70.398 79.02-70.398s74.324 30.293 79.02 70.316c0.33984 2.9883 0.51172 6.1445 0.51172 9.3867z",
		fill: "#474747"
	})
});
export default SvgIconPublicOpp;
